// dont delete...

export function clearPurchaseOrdersWindow() {
  return {
    type: 'CLEAR_PURCHASEORDERS_WIDGET',
  }
}

export function initPurchaseOrdersWindow() {
  return {
    type: 'INIT_PURCHASEORDERS_WIDGET',
  }
}

export function clearSkinTestListWindow() {
  return {
    type: 'CLEAR_SKINTESTLIST_WIDGET',
  }
}

export function initSkinTestListWindow() {
  return {
    type: 'INIT_SKINTESTLIST_WIDGET',
  }
}

export function clearVialTestListWindow() {
  return {
    type: 'CLEAR_VIALTESTLIST_WIDGET',
  }
}

export function initVialTestListWindow() {
  return {
    type: 'INIT_VIALTESTLIST_WIDGET',
  }
}

export function clearInjectionListWindow() {
  return {
    type: 'CLEAR_INJECTIONLIST_WIDGET',
  }
}

export function initInjectionListWindow() {
  return {
    type: 'INIT_INJECTIONLIST_WIDGET',
  }
}
